import type { FaireProductEntity } from "../../entity_types/product";

export const p_ammufzg3fw: FaireProductEntity = {
  token: "p_ammufzg3fw",
  type: "product",
  name: "Book Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e7f0784c8f2d3826c101a089e23390510bdf3c70629b57ca528f35db746d052a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f41d788ed777ff768ecac4ea2fd3c739735b0dff5d56442890761513ca22a8df.jpeg",
    "https://cdn.faire.com/fastly/10a2c15d3d5ec2a9b017316e76c861617fe06ba92e00916fbbbc74c087131471.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ce28dd3ebf9f25ecc47f6f03d63f51ed00af111e8fc4ff744016b62aed9acdf3.jpeg",
    "https://cdn.faire.com/fastly/bcb0ee66b3f5ef5ef5d1e93c26b8cae1156d1148b31fe8533cbd0456902cbf88.jpeg",
    "https://cdn.faire.com/fastly/a36862b4727cbffa33b58aada775c6f8197f510c461e908357a0fbbe26e6a044.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you like to get between those pages and just bury your face in a nice set of chapters... you're probably a book slut, and these socks are for you.\n\nA funny and edgy gift for book lovers, ideal for indie bookstores, spicy reading-themed displays, or literary subscription boxes. Perfect for readers who crave a bold statement with their socks.\n\nKey features of our Book Slut gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:58.810Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
